import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import styled from 'styled-components'


const ScrollContainer = styled.div`
  height: ${props => props.height || '300px'};
  overflow-y: auto;
  margin-right: -15px;
  
  &::-webkit-scrollbar {
    width: 8px;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: tranparent
    border-radius: 4px;
    transition: background 0.3s ease-in-out;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: rgba(100, 100, 100, 0.7);
    border-radius: 4px;
  }

  &:hover::-webkit-scrollbar {
    background: transparent;
  }
`;



/**
 * A reusable infinite scroll component.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} [props.height="300px"] - The height of the scroll container.
 * @param {number} props.dataLength - The current length of the data array.
 * @param {Function} props.next - Function to fetch more data when scrolled.
 * @param {boolean} props.hasMore - Determines if more data is available.
 * @param {string} [props.loaderMessage="Loading..."] - The message displayed while loading more data.
 * @param {React.ReactNode} [props.endMessage=<p>All items loaded</p>] - The message shown when all items are loaded.
 * @param {React.ReactNode} props.children - The list of items to display.
 * @param {string} [props.scrollableId="scroll-container"] - The ID of the scrollable container.
 * @returns {JSX.Element} - The InfinityScroller component.
 */

const InfiniteScroller = ({
  height,
  dataLength,
  next,
  hasMore,
  loaderMessage,
  endMessage,
  children,
  scrollableId = 'custom-scroll-container'
}) => {
  return (
    <ScrollContainer id={scrollableId} height={height}>
      <InfiniteScroll
        dataLength={dataLength}
        next={next}
        hasMore={hasMore}
        loader={
          <h5 style={{ textAlign: 'center', color: 'var(--main-color)' }}>
            {loaderMessage || 'Loading...'}
          </h5>
        }
        endMessage={
          <p style={{ textAlign: 'center', color: 'var(--main-color)' }}>
            {endMessage || 'All items loaded'}
          </p>
        }
        scrollableTarget={scrollableId}
      >
        {children}
      </InfiniteScroll>
    </ScrollContainer>
  )
}

export default InfiniteScroller
